import { z } from "zod";

export const UserDeleteRequestFormSchema = z.object({
  name: z.string().min(1, "Bitte gib deinen Namen ein."),
  mail: z.email({ message: "Bitte gib eine gültige E-Mail-Adresse ein." }),
});

export type UserDeleteRequestFormBody = z.infer<typeof UserDeleteRequestFormSchema>;
